<!-- 木桶结构： 关键字或者分类检索结果 图像盒子 -->
<template>
  <div
    class="ibox"
    @mouseover="showAddFavoriteBn"
    @mouseleave="hideAddFavoriteBn"
  >
    <div
      @click="openBigImg"
      class="iimgC"
      @mouseover="showTipInfoState = true"
      @mouseout="showTipInfoState = false"
    >
      <img :src="home_url" alt="" :style="imgStyle" />
      <div class="introductionInfoClass" v-show="showTipInfoState">
        <p class="contentFlowClass">
          {{ showTipInfoText }}
        </p>
      </div>
    </div>
    <span
      @click="addFavorite"
      title="加入收藏1"
      v-if="showFavorite"
      id="addFavor"
    >
      <el-button
        type="primary"
        icon="el-icon-star-off"
        circle
        size="mini"
      ></el-button>
    </span>
  </div>
</template>

<script>
const imgurl = '/md/front/paid/img/'
export default {
  props: {
    boxRole: Number, // 类型 1:分类检索类型列表  2：同组名查找列表 来触发不同的监听函数
    iHeight: Number,
    id: String,
    iname: String,
    isrc: String,
    idraw: String,
    imark: String,
    index: String,
    pos: String,
    len: String,
    posSrc: String,
    lenSrc: String,
    label: String,
    level: String,
    iClass: String, // 子类名
    titleG: String, // 分组名
    clearBG: String // 背景处理
  },
  data () {
    return {
      minName: '',
      home_url: imgurl + 'swimg/' + this.pos + '/' + this.len,
      iinfo: this.isrc,
      srcList: [
        // imgurl + 'view/' + this.id + '/' + this.iname
      ],
      showFavorite: false,
      isAdd: false, // 是否已经被添加到收藏
      showTipInfoState: false,
      showTipInfoText: '获取中...',
      showTipSubInfoNowIndex: 0,
      showTipInfoIntervalAddress: null
    }
  },
  methods: {
    hideAddFavoriteBn () {
      this.showFavorite = false
    },
    showAddFavoriteBn () {
      if (!this.isAdd) {
        this.showFavorite = true
      }
    },
    addFavorite () {
      const api = '/md/front/additional/collection/add'
      const params = {
        imgId: this.id,
        imgInfo:
          this.iname +
          ':' +
          this.isrc +
          ':' +
          this.idraw +
          ':' +
          this.imark +
          ':' +
          this.iClass +
          ':' +
          this.titleG +
          ':' +
          this.clearBG +
          ':' // 新增的3个属性
      }
      this.axios.post(api, this.$stringify(params)).then(res => {
        if (res.status === 200) {
          // 添加成功
          this.showFavorite = false
          this.isAdd = true // 这样鼠标再滑入 就不会出现按钮了
          this.$alert('收藏成功', '提示')
        }
      })
    },
    openBigImg () {
      let imgInfo =
        this.iname + ':' + this.isrc + ':' + this.idraw + ':' + this.imark + ':'
      imgInfo =
        imgInfo + this.iClass + ':' + this.titleG + ':' + this.clearBG + ':' // 新增的3个属性
      this.$store.commit('setGlobalObjOfShowImgID', this.id)
      this.$store.commit('setGlobalObjOfShowImgInfo', imgInfo)
      if (this.$route.path === '/imgList/convas') {
        this.$store.commit('flipShowImageState')
      } else {
        this.$router
          .push({
            path: '/imgList/convas'
          })
          .catch(() => {})
      }
    }
  },
  mounted () {
    this.minName = this.iname
    if (this.minName.length > 14) {
      this.minName = this.iname.substring(0, 13) + '...'
    }
  },
  computed: {
    imgStyle () {
      return {
        height: this.iHeight + 'px'
      }
    }
  },
  watch: {
    showTipInfoState (newV) {
      if (newV) {
        const sourceTitle = this.iname
        // console.log(sourceTitle)
        if (typeof sourceTitle === 'undefined') {
          return
        }
        if (this.showTipInfoIntervalAddress) {
          return
        }
        this.showTipInfoIntervalAddress = setInterval(() => {
          const textMaxLength = 8
          if (sourceTitle.length <= textMaxLength + 1) {
            this.showTipInfoText = sourceTitle
            return
          }
          let subStr = sourceTitle.substr(
            this.showTipSubInfoNowIndex,
            textMaxLength
          )
          if (subStr.length < 1) {
            this.showTipSubInfoNowIndex = 0
            subStr = sourceTitle.substr(
              this.showTipSubInfoNowIndex,
              textMaxLength
            )
          }
          this.showTipInfoText = subStr
          this.showTipSubInfoNowIndex += 1
        }, 300) // 每过一秒改一次
      } else {
        const textMaxLength = 8
        clearInterval(this.showTipInfoIntervalAddress)
        this.showTipInfoIntervalAddress = null
        this.showTipSubInfoNowIndex = 0
        this.showTipInfoText = this.iname.substr(
          this.showTipSubInfoNowIndex,
          textMaxLength
        )
      }
    }
  }
}
</script>
<style scoped>
.ibox {
  width: 100%;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  border: 0px solid #963;
  position: relative;
  background-color: transparent;
}

.iname {
  width: 100%;
  height: 30px;
  line-height: 30px;
  color: #fff;
  text-align: center;
  font-size: 15px;
  margin-bottom: 0px;
}

.iimgC {
  height: 100%;
  text-align: center;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
}

.iimgC img {
  cursor: pointer;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
}

#addFavor {
  position: absolute;
  right: 12px;
  top: 6px;
  cursor: pointer;
  font-size: 30px; /*控制ui 图标的大小*/
}

.el-image {
  position: relative;
  display: block;
}
.introductionInfoClass {
  /**给图片加描述信息的阴影 */
  z-index: 1;
  width: 100%;
  height: 2rem;
  position: absolute;
  bottom: 0rem;
  left: 0rem;
  box-shadow: inset 0px 29px 2px rgba(15, 13, 13, 0.616);
}
.contentFlowClass {
  /*给描述信息的文字设置属性  */
  width: 100%;
  display: inline-block;
  font-size: 12px;
  color: #fff;
  line-height: 10px;
}
</style>
